module.exports = __webpack_public_path__ + "static/media/separation.a8e3c815.svg";